// extracted by mini-css-extract-plugin
module.exports = {"loginFormForm":"ForgotPasswordForm_loginFormForm__2jMfC","submitButton":"ForgotPasswordForm_submitButton__3vUzd","formError":"ForgotPasswordForm_formError__XQA7u"};